import React, { useState } from "react";
import "../../../../assets/styles/waitingListLead/WaitingListLeadOverview.scss";
import EmailModal from "./EmailModalNew";
import { WaitingListLeadState } from "../types/enums";
import { getCommaSeparatedPhoneNumberFromArray } from "lib/leadNumber/phoneNumber";
import WaitingListLeadBasicInformationTableV1 from "./WaitingListLeadBasicInformationTableV1";
import WaitingListLeadProductCriteriaInformationTableV1 from "./WaitingListLeadProductCriteriaInformationTableV1";
import { ILeadPhoneNumber } from "types";
import CrossSellSection from "./CrossSellingSection";
import DocumentCenter from "./DocumentCenter";

interface Activity {
    icon: string;
    time: string;
    text: string;
    // Für E‑Mails erweitern wir zusätzlich Detailfelder
    sender?: string;
    recipient?: string;
    subject?: string;
    body?: string;
    attachment?: any;
}

interface Todo {
    id: number;
    title: string;
    deadline: string;
    done: boolean;
}


interface ContactInfo {
    firstName: string;
    lastName: string;
    clientAvailability: string;
    phoneNumbers: ILeadPhoneNumber[];
    email?: string;
}

interface MiddleSectionProps {
    contactInfo: ContactInfo | null;
    activityLog: Activity[];
    emailActivities: Activity[];
    noteActivities: Activity[];
    callActivities: Activity[];
    taskActivities: Activity[];
    mockData: any; // Hier den Typ für mockData anpassen
    //selectedEmail, setSelectedEmail
    selectedEmail: boolean;
    setSelectedEmail: (selectedEmail: boolean) => void;
    getWaitingListLeadStatusView: (
        state: WaitingListLeadState,
        isClosedByClient: boolean,
        isPersonalProduct: boolean
    ) => JSX.Element;
}

const MiddleSection: React.FC<MiddleSectionProps> = ({
    contactInfo,
    activityLog,
    emailActivities,
    noteActivities,
    callActivities,
    taskActivities,
    mockData,
    selectedEmail,
    setSelectedEmail,
    getWaitingListLeadStatusView
}) => {
    const [activeTab, setActiveTab] = useState("aktivität");
    const [todos, setTodos] = useState<Todo[]>([]);

    const tabs = ["aktivität", "anrufe", "e-Mails", "aufgaben", "kriterien", "dokumente", "Zusatzbedarf"];

    const handleEmailClick = () => {
        setSelectedEmail(!selectedEmail);
    };

    const addTodo = () => {
        const nextId = todos.length ? Math.max(...todos.map(t => t.id)) + 1 : 1;
        setTodos([...todos, { id: nextId, title: "", deadline: "", done: false }]);
    };

    // Funktion, um ein To‑Do zu updaten
    const updateTodo = (id: number, field: keyof Omit<Todo, "id">, value: any) => {
        setTodos(todos.map(t => t.id === id ? { ...t, [field]: value } : t));
    };


    return (
        <div className="middle-section">
            <div className="search-bar">
                <input type="text" placeholder="Suche..." />
            </div>
            <div className="tabs">
                {tabs.map(tab => (
                    <button
                        key={tab}
                        className={activeTab === tab ? "active" : ""}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                ))}
            </div>
            <div className="tab-content">
                {activeTab === "aktivität" && (
                    <div className="activities">
                        <h2>Aktivitäten</h2>
                        {activityLog
                            .sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime())
                            .map((activity, index) => (
                                <div key={index} className="activity"
                                    onClick={() => handleEmailClick()}
                                >
                                    <i className={activity.icon} /> {activity.time} - {activity.text}
                                </div>
                            ))}
                        {mockData.waitingListLeadDetailsInfo &&
                            getWaitingListLeadStatusView(
                                mockData.waitingListLeadDetailsInfo.waitingListLeadState,
                                mockData.waitingListLeadDetailsInfo.isClosedByClient,
                                mockData.waitingListLeadDetailsInfo.isPersonalProduct
                            )}
                    </div>
                )}
                {activeTab === "anrufe" && (
                    <div className="calls">
                        <h2>Anrufe</h2>
                        {callActivities.length > 0 ? (
                            callActivities
                                .sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime())
                                .map((activity, index) => (
                                    <div key={index} className="activity">
                                        <i className={activity.icon} /> {activity.time} - {activity.text}
                                    </div>
                                ))
                        ) : (
                            <p>Keine Anrufe vorhanden.</p>
                        )}
                    </div>
                )}
                {activeTab === "e-Mails" && (
                    <div className="emails">
                        <h2>E‑Mails</h2>
                        {emailActivities.length > 0 ? (
                            emailActivities
                                .sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime())
                                .map((email, index) => (
                                    <div
                                        key={index}
                                        className="activity"
                                        onClick={() => handleEmailClick()}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <i className={email.icon} /> {email.time} - {email.text}
                                    </div>
                                ))
                        ) : (
                            <p>Keine E‑Mails vorhanden.</p>
                        )}
                    </div>
                )}
                {activeTab === "notizen" && (
                    <div className="notes">
                        <h2>Notizen</h2>
                        {noteActivities.length > 0 ? (
                            noteActivities
                                .sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime())
                                .map((activity, index) => (
                                    <div key={index} className="activity">
                                        <i className={activity.icon} /> {activity.time} - {activity.text}
                                    </div>
                                ))
                        ) : (
                            <p>Keine Notizen vorhanden.</p>
                        )}
                    </div>
                )}
                {activeTab === "aufgaben" && (
                    <div className="tasks">
                        <h2>Aufgaben</h2>
                        {taskActivities.length > 0 ? (
                            taskActivities
                                .sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime())
                                .map((activity, index) => (
                                    <div key={index} className="activity">
                                        <i className={activity.icon} /> {activity.time} - {activity.text}
                                    </div>
                                ))
                        ) : (
                            <p>Keine Aufgaben vorhanden.</p>
                        )}
                    </div>
                )}
                {activeTab === "kriterien" && (
                    <>
                        <div className="criteria-table">
                            <h2>Alle Kriterien</h2>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Kriterium</th>
                                        <th>Ausgewählte Option</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {mockData.waitingListLeadDetailsInfo.productCriteriaList.map(
                                        (criteria: { criteriaName: any; value: any }, index: number) => (
                                            <tr key={index}>
                                                <td>{criteria.criteriaName}</td>
                                                <td>{criteria.value}</td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>

                            {/* --- Statischer Demo-Abschnitt: Aus Dokumenten extrahierte Kriterien --- */}
                            <h2 style={{ marginTop: 20 }}>Aus Dokumenten extrahierte Details</h2>
                            <table className="criteria-table-extracted">
                                <thead>
                                    <tr>
                                        <th>Quelle</th>
                                        <th>Kriterium</th>
                                        <th>Wert</th>
                                        <th>Extrahiert am</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td> <i className="fa-solid fa-file-pdf" /> </td>
                                        <td>Medikation</td>
                                        <td>Metformin&nbsp;1000&nbsp;mg – morgens &amp; abends (N)</td>
                                        <td>19.09.2025</td>
                                    </tr>
                                    <tr>
                                        <td> <i className="fa-solid fa-file-pdf" /> </td>
                                        <td>Medikation</td>
                                        <td>Ramipril&nbsp;5&nbsp;mg – morgens (Z)</td>
                                        <td>19.09.2025</td>
                                    </tr>
                                    <tr>
                                        <td> <i className="fa-solid fa-file-pdf" /> </td>
                                        <td>Medikation</td>
                                        <td>Ibuprofen&nbsp;400&nbsp;mg – abends (V)</td>
                                        <td>19.09.2025</td>
                                    </tr>
                                    <tr>
                                        <td> <i className="fa-solid fa-file-pdf" /> </td>
                                        <td>Medikation</td>
                                        <td>Pantoprazol&nbsp;20&nbsp;mg – morgens (Z)</td>
                                        <td>19.09.2025</td>
                                    </tr>

                                    <tr>
                                        <td> <i className="fa-solid fa-file-pdf" /> </td>
                                        <td>Medikation</td>
                                        <td>ASS&nbsp;100&nbsp;mg – abends (V)</td>
                                        <td>19.09.2025</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ fontSize: 12, color: "#64748b", marginTop: 6 }}>
                                Legende Zusatzinfo: V = vor der Mahlzeit, Z = zur Mahlzeit, N = nach der Mahlzeit
                            </div>
                            {/* --- Ende statischer Demo-Abschnitt --- */}
                        </div>
                    </>
                )}

                {activeTab === "Zusatzbedarf" && (
                    <div className="create-request-body">
                        <h2>Zusatzbedarf</h2>

                        <CrossSellSection />
                    </div>
                )}

                {activeTab === "dokumente" && (
                    <div className="create-request-body">
                        <DocumentCenter />
                    </div>
                )}


                {activeTab === "termine" && (
                    <div className="appointments">
                        <h2>{mockData.tabContent.appointments.title}</h2>
                        <p>{mockData.tabContent.appointments.text}</p>
                    </div>
                )}
                {activeTab === "kontaktdetails" && (
                    <div className="contact-details-tab">
                        <h2>{mockData.tabContent.contactDetailsTitle}</h2>
                        {mockData.waitingListLeadDetailsInfo && (
                            <>
                                <WaitingListLeadBasicInformationTableV1
                                    firstName={mockData.waitingListLeadDetailsInfo.firstName}
                                    lastName={mockData.waitingListLeadDetailsInfo.lastName}
                                    productName={mockData.waitingListLeadDetailsInfo.productName}
                                    clientAvailability={mockData.waitingListLeadDetailsInfo.clientAvailability}
                                    waitingListLeadState={mockData.waitingListLeadDetailsInfo.waitingListLeadState}
                                    requestRegion={mockData.waitingListLeadDetailsInfo.requestRegion}
                                    requestZipCode={mockData.waitingListLeadDetailsInfo.requestZipCode}
                                    phoneNumber={getCommaSeparatedPhoneNumberFromArray(
                                        mockData.waitingListLeadDetailsInfo.phoneNumbers
                                    )}
                                    isClosedByClient={mockData.waitingListLeadDetailsInfo.isClosedByClient}
                                    isPersonalProduct={mockData.waitingListLeadDetailsInfo.isPersonalProduct}
                                />
                                <WaitingListLeadProductCriteriaInformationTableV1
                                    waitingListLeadCriteriaInfo={{
                                        waitingListLeadState: mockData.waitingListLeadDetailsInfo.waitingListLeadState,
                                        isClosedByClient: mockData.waitingListLeadDetailsInfo.isClosedByClient,
                                        isPersonalProduct: mockData.waitingListLeadDetailsInfo.isPersonalProduct,
                                        productCriteriaList: mockData.waitingListLeadDetailsInfo.productCriteriaList
                                    }}
                                />
                            </>
                        )}
                    </div>
                )}
            </div>
            {selectedEmail && (
                <EmailModal onClose={() => handleEmailClick()} />
            )}
        </div>
    );
};

export default MiddleSection;
